import '.d{display:flex;}.ssr-plugin'
import '.af{align-items:stretch;}.ssr-plugin'
import '.a3{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.e3{background:var(--palette-white);}.ssr-plugin'
import '.ah{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.an{max-width:77.5rem;}.ssr-plugin'
import '.fm{justify-content:stretch;}.ssr-plugin'
import '.bl{position:sticky;}.ssr-plugin'
import '.bm{top:0px;}.ssr-plugin'
import '.bq{z-index:10;}.ssr-plugin'
import '.fn{padding-block:1rem;}.ssr-plugin'
import '.fo{height:3rem;}.ssr-plugin'
import '.b5{justify-content:space-between;}.ssr-plugin'
import '.b8{flex-wrap:wrap;}.ssr-plugin'
import '.fp{margin-bottom:0px;}.ssr-plugin'
import '.fq{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.eu{margin-top:2rem;}.ssr-plugin'
import '.fr{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <>
      <PageSeo pageTitle={title} noindex />
      <ClientOnly>
      <div className="d af a3 e e3"
      >
        <div className="ah d r a3 e"
        >
          <div className="an d e fm bl bm bq e3"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fn fo d b5 r b8"
            >
              <styled.span className="fp"
                style={{
                  ...getTitleLevelStyle(5, isMobile),}}
              >
                {title}
              </styled.span>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="fq d e af eu fr an"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
